import axios from 'axios'

// Corevas = unified MVAS platform (auth + subscription).
// Content still goes through the Apollo/GraphQL client; this instance is only
// for the corevas auth endpoints (login/me/logout/unsubscribe).
export const corevasAxios = axios.create({
  baseURL: process.env.VUE_APP_COREVAS_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})
